"use client";

import { c as _c } from "react/compiler-runtime";
import { IconBrainOutline18, IconCodeBranchOutline18, IconDatabaseOutline18, IconMonitorOutline18, IconShieldOutline18, IconStarUserOutline18, IconUsersOutline18 } from "nucleo-ui-outline-18";
import Image from "next/image";
import { motion } from "framer-motion";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { TIER_ICON_MAP } from "./pricing-data";
import type { PricingTier } from "./pricing-data";
interface EnterpriseBannerProps {
  tier: PricingTier;
  isCurrentTier?: boolean;
}
const ENTERPRISE_FEATURES = [{
  icon: IconCodeBranchOutline18,
  label: "Unlimited",
  sublabel: "active workflows"
}, {
  icon: IconDatabaseOutline18,
  label: "Custom",
  sublabel: "database tables"
}, {
  icon: IconMonitorOutline18,
  label: "Custom",
  sublabel: "CU/month"
}, {
  icon: IconBrainOutline18,
  label: "Custom",
  sublabel: "AI credits"
}, {
  icon: IconUsersOutline18,
  label: "Unlimited",
  sublabel: "users"
}, {
  icon: IconShieldOutline18,
  label: "Custom",
  sublabel: "SLA & support"
}, {
  icon: IconStarUserOutline18,
  label: "Dedicated",
  sublabel: "account manager"
}];
export function EnterpriseBanner(t0) {
  const $ = _c(27);
  const {
    tier,
    isCurrentTier
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      opacity: 0,
      y: 30
    };
    t2 = {
      opacity: 1,
      y: 0
    };
    t3 = {
      duration: 0.5,
      delay: 0.9
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  const t4 = isCurrentTier && "ring-2 ring-green-500/70";
  let t5;
  if ($[3] !== t4) {
    t5 = cn("border-ds-border-default bg-ds-neutral-100 overflow-hidden rounded-[24px] border", t4);
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="flex items-center gap-2 px-6 py-3"><Image src={TIER_ICON_MAP.enterprise} alt="Enterprise plan icon" width={16} height={16} className="size-4" /><p className="text-ds-text-secondary font-mono text-base font-medium uppercase leading-[1.2] tracking-[-0.32px]">Enterprise</p></div>;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <h3 className="text-ds-text-primary text-3xl font-medium tracking-tight md:text-4xl">Custom price</h3>;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== tier.description) {
    t8 = <p className="text-ds-text-primary mt-2 max-w-lg text-sm leading-[1.2]">{tier.description}{". Custom CU & AI credit allocation tailored to your organization's needs."}</p>;
    $[7] = tier.description;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== isCurrentTier) {
    t9 = isCurrentTier && <Badge variant="success" className="mt-2 border border-green-200 bg-green-50/95 px-3 py-1 text-xs">Current Plan</Badge>;
    $[9] = isCurrentTier;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t8 || $[12] !== t9) {
    t10 = <div className="flex-1">{t7}{t8}{t9}</div>;
    $[11] = t8;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== isCurrentTier || $[15] !== tier.ctaHref) {
    t11 = <div className="shrink-0">{isCurrentTier ? <button disabled={true} className="relative flex h-11 items-center justify-center overflow-hidden rounded-xl px-8 opacity-60"><span aria-hidden="true" className="from-ds-neutral-150 to-ds-neutral-250 pointer-events-none absolute inset-0 rounded-xl bg-gradient-to-b" /><span className="rounded-inherit pointer-events-none absolute inset-0 shadow-[inset_0px_1px_0px_0px_rgba(255,255,255,0.35)]" /><span className="text-ds-text-primary relative text-sm font-medium">Current Plan</span></button> : <a href={tier.ctaHref} className="relative flex h-11 items-center justify-center overflow-hidden rounded-xl px-8 shadow-[0px_3px_4px_-1px_rgba(23,22,25,0.15),0px_0px_0px_1px_rgba(23,22,25,0.1)]"><span aria-hidden="true" className="from-ds-text-tertiary to-ds-neutral-900 pointer-events-none absolute inset-0 rounded-xl bg-gradient-to-b" /><span className="rounded-inherit pointer-events-none absolute inset-0 shadow-[inset_0px_1px_0px_0px_rgba(255,255,255,0.35)]" /><span className="text-ds-white-2 relative text-sm font-medium">Contact Sales</span></a>}</div>;
    $[14] = isCurrentTier;
    $[15] = tier.ctaHref;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t10 || $[18] !== t11) {
    t12 = <div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between">{t10}{t11}</div>;
    $[17] = t10;
    $[18] = t11;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <p className="text-ds-text-primary mb-3 text-sm font-medium">What's included:</p>;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="mt-6">{t13}<div className="flex flex-wrap gap-x-6 gap-y-2">{ENTERPRISE_FEATURES.map(_temp)}</div></div>;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== t12) {
    t15 = <div className="border-ds-border-default rounded-[24px] border bg-white p-6 md:p-8">{t12}{t14}</div>;
    $[22] = t12;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== t15 || $[25] !== t5) {
    t16 = <motion.div initial={t1} animate={t2} transition={t3} className="mt-6"><div className={t5}>{t6}{t15}</div></motion.div>;
    $[24] = t15;
    $[25] = t5;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  return t16;
}
function _temp(item) {
  return <div key={`${item.label}-${item.sublabel}`} className="flex items-center gap-2"><item.icon className="text-ds-text-subtle size-5 shrink-0" /><span className="text-sm leading-[1.2]"><span className="text-ds-text-primary font-medium">{item.label}</span>{" "}<span className="text-ds-text-subtle">{item.sublabel}</span></span></div>;
}